module.exports = __webpack_public_path__ + "static/media/Roboto-500.90d16760.woff2";